import axiosInstance from "./axiosInstance";
import { BASE_URL } from "../constants/applicationConfig";

const BASE_URL_MEALS = `${BASE_URL}/api/user-meals`;

export class UserMealApi {
  static async createMeal(meal) {
    return (await axiosInstance.post(`${BASE_URL_MEALS}`, meal)).data;
  }

  static async fetchAll() {
    return (await axiosInstance.get(`${BASE_URL_MEALS}`)).data;
  }

  static async fetchById(id) {
    return (await axiosInstance.get(`${BASE_URL_MEALS}/${id}`)).data;
  }

  static async deleteById(id) {
    return (await axiosInstance.delete(`${BASE_URL_MEALS}/${id}`))
      .data;
  }

  static async updateById(id, meal) {
    return (await axiosInstance.patch(`${BASE_URL_MEALS}/${id}`, meal)).data;
  }

  static async replaceById(mealId, meal) {
    return (await axiosInstance.put(`${BASE_URL_MEALS}/${mealId}`, meal)).data;
  }
}
